import React from "react"
import { Card } from "../../../designSystem/Card";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { FluidLeftFixedRightLayoutColumns } from "../../../designSystem/layouts/FluidLeftFixedRightLayout";
import { H3, H4 } from "../../../designSystem/typography/Heading";
import { ResponsiveColumns } from '../../../designSystem/ResponsiveColumns';
import { DeviceView } from "../../../designSystem/DeviceView";



export const LayoutOverview = (): JSX.Element => 
{
    return (
        <Flex flexDirection='column' gap={64}>
            
            <Flex flexDirection='column' gap={16}>
                <H3>FluidLeftFixedRightLayoutColumns</H3>
                <FluidLeftFixedRightLayoutColumns
                    leftContainer={
                        <Card>
                            <H3>Left Container</H3>
                        </Card>
                    }
                    rightContainer={
                        <Card>
                            <H3>Right Container</H3>
                        </Card>
                    } />
            </Flex>
            
            <Flex flexDirection='column' gap={16}>
                <H3>ResponsiveColumns</H3>
                <H4>no fullWidth, 10 px columnGap, 30 px rowGap</H4>
                <ResponsiveColumns columnCount={3} tabletColumnCount={2} mobileColumnCount={1} columnGap={10} rowGap={30}>
                    <Card>
                        <H3>Card 1</H3>
                    </Card>
                    <Card>
                        <H3>Breaks for mobile</H3>
                    </Card>
                    <Card>
                        <H3>Breaks for tablet</H3>
                    </Card>
                </ResponsiveColumns>
            </Flex>

            <Flex flexDirection='column' gap={16}>
                <H3>fullWidth, 5 px columnGap, 5 px rowGap</H3>
                <ResponsiveColumns columnCount={2} tabletColumnCount={1} mobileColumnCount={1} columnGap={5} rowGap={5} fullWidth>
                    <Card>
                        <H3>Card 1</H3>
                    </Card>
                    <Card>
                        <H3>Breaks for tablet & mobile</H3>
                    </Card>
                </ResponsiveColumns>
            </Flex>

            <Flex flexDirection='column' gap={16}>
                <H3>DeviceView (mobile/tablet/desktop)</H3>
                <ResponsiveColumns columnCount={1} tabletColumnCount={1} mobileColumnCount={2} columnGap={16} rowGap={16}>
                    <DeviceView
                        mobile={
                            <Card>
                                <H3>Denne er vist på mobil</H3>
                            </Card>
                        }
                        tablet={
                            <Card>
                                <H3>Denne er vist på tablet</H3>
                            </Card>
                        }
                        desktop={
                            <Card>
                                <H3>Denne er vist på desktop</H3>
                            </Card>
                        } />
                </ResponsiveColumns>
            </Flex>
        </Flex>
    );
}